// extracted by mini-css-extract-plugin
module.exports = {"figure":"figure-module--figure--2Rh9B","image":"figure-module--image--1aUNO"};